export enum RedirectOAuthPages {
  SignIn = 'signIn',
  SignOut = 'signOut',
}
